{
  "app": {
    "name": "Tokki"
  },
  "common": {
    "back": "Back",
    "retry": "Retry",
    "backToHome": "Back to home",
    "loading": "Loading…",
    "dismiss": "Dismiss"
  },
  "home": {
    "greeting": "Hi, {{name}}",
    "guestName": "there",
    "subtitle": "Your Tokki mini app is ready.",
    "statusTitle": "Environment",
    "statusDescription": "Running in {{environment}} mode"
  },
  "notFound": {
    "title": "Page not found",
    "description": "The page you are looking for does not exist."
  },
  "routeError": {
    "title": "Something went wrong",
    "description": "An unexpected error occurred. Please try again."
  },
  "telegram": {
    "unsupportedTitle": "Open Tokki in Telegram",
    "unsupportedDescription": "This app runs as a Telegram Mini App. Please open it from the Tokki bot."
  },
  "error": {
    "network": "Network error. Please check your connection.",
    "timeout": "The request timed out. Please try again.",
    "unexpectedResponse": "The server returned an unexpected response ({{status}}).",
    "unknown": "Something went wrong. Please try again.",
    "sessionExpired": "Your session has expired. Please reopen the app from Telegram."
  }
}
